export default __webpack_public_path__ + "static/media/CaramelFamily.2257de5d.jpg";